// extracted by mini-css-extract-plugin
export default {"label":"styles_label__q6B+4"};